import { render } from "./SettingsBlock.vue?vue&type=template&id=2d1bb390"
import script from "./SettingsBlock.vue?vue&type=script&lang=js"
export * from "./SettingsBlock.vue?vue&type=script&lang=js"

import "./SettingsBlock.vue?vue&type=style&index=0&id=2d1bb390&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__